// LMSC-58939-User Story - Navigation Menu - Landing Page - “Dropdown list” Menu Items – Branch user based on
// Profile Configuration

interface IBranchUserPageAccessRights {
    OfferMenu: string
    RequestASpotRate: string
    ACSpotRateOffers: string
    AISpotRateOffers: string
    MHSpotRateOffers: string
    NZSpotRateOffers: string
    SKSpotRateOffers: string
    UWSpotRateOffers: string
    Marketplace: string
    Booking: string
    SearchAvailabilityAndPrice: string
    SearchAvailableSpace: string
    SearchAirWaybillStock: string
    CreateModifyBookingNew: string
    CreateModifyBookingOld: string
    CreateMultipleBookings: string
    CreateModifyBookingTemplates: string
    CreateRecurringBookingTemplate: string
    CreateSpreadsheetBookings: string
    CreateAirWaybillStockRequest: string
    CreateAllotmentRequest: string
    ViewAllotmentStatus: string
    ViewRateEstimate: string
    ViewCarrierSchedules: string
    Efreight: string
    CreateRetrieveMAWB: string
    RetrieveeDocs: string
    CreateModifyHAWB: string
    CreateModifyHAWBTemplates: string
    CreateModifyPieceIDInfo: string
    ManageShipments: string
    TrackShipments: string
    SearchAirWaybills: string
    ViewModifyBooking: string
    ReviewActiveQueuedBookings: string
    PrintBarcodeShippingLabel: string
    PrintShipperLetterOfInstruction: string
    MakeOnlinePayments: string
    ViewFlightStatus: string
    ViewCustomsStatus: string
    ViewArchivedAirWaybill: string
    ShipmentReleaseDeclaration: string
    Edocs: string
    MyBookingDocuments: string
    AirWaybillDocuments: string
    Efinance: string
    ViewInvoices: string
    ViewPaymentDetails: string
    eClaims: string
    CreateModifyPreliminaryClaim: string
    CreateModifyFinalClaim: string
    ViewACClaimStatus: string
    ViewAIClaimStatus: string
    ViewMHClaimStatus: string
    ViewSKClaimStatus: string
}

interface IBranchUserAuthorizationConfig {
    isBranchMemberStatus: boolean
    isBranchAdministratorStatus: boolean
    isCoLoaderStatus: boolean
    isBookingAuthorization: boolean
    isRateAuthorization: boolean
    isAllocationAuthorization: boolean
}

const UserPrevilages = () => {
    const userConfigKey1: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const userConfigValue1: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    // Create more BranchUserAuthorizationConfig instances for other configurations

    const userConfigKey2: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const userConfigValue2: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey3: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const userConfigValue3: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey4: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const userConfigValue4: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey5: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const userConfigValue5: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey6: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: true,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }
    const userConfigValue6: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'N',
        ACSpotRateOffers: 'N',
        AISpotRateOffers: 'N',
        MHSpotRateOffers: 'N',
        NZSpotRateOffers: 'N',
        SKSpotRateOffers: 'N',
        UWSpotRateOffers: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocuments: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const userConfigKey7: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const userConfigValue7: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey8: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const userConfigValue8: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey9: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const userConfigValue9: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey10: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const userConfigValue10: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey11: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const userConfigValue11: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey12: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const userConfigValue12: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey13: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const userConfigValue13: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey14: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const userConfigValue14: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey15: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const userConfigValue15: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey16: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const userConfigValue16: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userConfigKey17: IBranchUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const userConfigValue17: IBranchUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        ACSpotRateOffers: 'Y',
        AISpotRateOffers: 'Y',
        MHSpotRateOffers: 'Y',
        NZSpotRateOffers: 'Y',
        SKSpotRateOffers: 'Y',
        UWSpotRateOffers: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocuments: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const userHashMap = new Map<IBranchUserAuthorizationConfig, IBranchUserPageAccessRights>()
    userHashMap.set(userConfigKey1, userConfigValue1)
    userHashMap.set(userConfigKey2, userConfigValue2)
    userHashMap.set(userConfigKey3, userConfigValue3)
    userHashMap.set(userConfigKey4, userConfigValue4)
    userHashMap.set(userConfigKey5, userConfigValue5)
    userHashMap.set(userConfigKey6, userConfigValue6)
    userHashMap.set(userConfigKey7, userConfigValue7)
    userHashMap.set(userConfigKey8, userConfigValue8)
    userHashMap.set(userConfigKey9, userConfigValue9)
    userHashMap.set(userConfigKey10, userConfigValue10)
    userHashMap.set(userConfigKey11, userConfigValue11)
    userHashMap.set(userConfigKey12, userConfigValue12)
    userHashMap.set(userConfigKey13, userConfigValue13)
    userHashMap.set(userConfigKey14, userConfigValue14)
    userHashMap.set(userConfigKey15, userConfigValue15)
    userHashMap.set(userConfigKey16, userConfigValue16)
    userHashMap.set(userConfigKey17, userConfigValue17)

    return userHashMap
}
export default UserPrevilages
